import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantAgendasRoot = () => {
  useProtected();

  return <Outlet />;
};

export { AgendasPage } from "./Agendas";
export { AgendaPage } from "./Agenda";
